
import React from 'react';
import ResultModel from './ResultModel';
import CCOApiConnector from './CCOApiConnector';
import Progressbar from './Progressbar';

export default class LOResult extends React.Component {

    state = {
        resultModels: []
    }


    componentDidMount = () => {

        let { app, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let { resultModels } = this.state


        let ccoApiConnector = new CCOApiConnector()

        let loIdsFilter = []
        for (let i = 0; i < quizViwerModel.activityArr.length; i++) {
            let activity = quizViwerModel.activityArr[i];
            for (let j = 0; j < activity.loList.length; j++) {
                let lo = activity.loList[j];
                let isExisted = false;
                for (let k = 0; k < loIdsFilter.length; k++) {

                    if (lo.lo == loIdsFilter[k]) {
                        isExisted = true;
                        resultModels[k].total++;
                        if (activity.answeredTrue) {
                            resultModels[k].right++;
                        } else {
                            resultModels[k].wrong++;
                        }
                    }
                }
                if (!isExisted) {
                    loIdsFilter.push(lo.lo);
                    let resultModel = new ResultModel(0,"",0,0,0);
                    resultModel.title = lo.lo + "";
                    resultModel.id = lo.lo;
                    resultModel.total++;
                    if (activity.answeredTrue) {
                        resultModel.right++;
                    } else {
                        resultModel.wrong++;
                    }
                    resultModels.push(resultModel);
                }

            }
        }

        let loIdsJson = [];
        resultModels.map(obj => {
            loIdsJson.push(obj.id);
        })

      
        ccoApiConnector.getLOTitles(loIdsJson, res => {

            let detail = res.data.detail

            for (let i = 0; i < detail.length; i++) {
                resultModels[i].title = detail[i].LO_NAME;
            }


            this.setState({resultModels})

        })

    }




    render = () => {

        let { resultModels } = this.state

        return (
            <>
                {
                    resultModels.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Progressbar resultModel={item} />
                            </React.Fragment>
                        )
                    })
                }
            </>
        )
    }

}